import React, { useState } from 'react';
import { ConsumptionControlTable } from './ConsumptionSettings_Components.js';

const ConsumptionSettings = ({ initialConsumptionConfigs, onSave, saveStatus }) => {
  const [consumptionConfig, setConsumptionConfig] = useState(initialConsumptionConfigs);
 
  if (!consumptionConfig || Object.keys(consumptionConfig).length === 0) {
    return <div>Loading configuration data...</div>;
  }

  const handleToggleEnabled = (serviceId, field, isEnabled) => {
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        [field]: isEnabled,
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleControlToggle = (serviceId, isEnabled) => {
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        controller: {
          ...prevConfig[serviceId].controller,
          enabled: isEnabled,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleOverrideToggle = (serviceId, isEnabled) => {
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        override: {
          ...prevConfig[serviceId].override,
          enabled: isEnabled,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleHoursChange = (serviceId, settingType, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);
    
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        [settingType]: {
          ...prevConfig[serviceId][settingType],
          hours: parsedValue,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handlePriceBasedHoursChange = (serviceId, priceIndex, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);
    
    setConsumptionConfig((prevConfig) => {
      const service = prevConfig[serviceId];
      // Create a deep copy of the hours array
      const updatedHours = [...service.controller.hours];
      
      // Update the specific price range hours
      updatedHours[priceIndex] = {
        ...updatedHours[priceIndex],
        hours: parsedValue
      };
      
      const updatedService = {
        ...service,
        controller: {
          ...service.controller,
          hours: updatedHours
        }
      };
      
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleCurrentAChange = (serviceId, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);
    
    setConsumptionConfig((prevConfig) => {
      const service = prevConfig[serviceId];
      
      // If actor doesn't exist, create it
      const currentActor = service.actor || {};
      
      const updatedService = {
        ...service,
        actor: {
          ...currentActor,
          currentA: parsedValue
        }
      };
      
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleOverrideTypeChange = (serviceId, type) => {
    // When changing to fixed_hours, ensure hours is initialized if it doesn't exist
    setConsumptionConfig((prevConfig) => {
      const currentOverride = prevConfig[serviceId].override;
      const updatedOverride = {
        ...currentOverride,
        type: type,
      };
      
      // Initialize hours to 1 if switching to fixed_hours and hours is not set
      if (type === 'fixed_hours' && (currentOverride.hours === undefined || currentOverride.type !== 'fixed_hours')) {
        updatedOverride.hours = currentOverride.hours || 1;
      }
      
      const updatedService = {
        ...prevConfig[serviceId],
        override: updatedOverride,
      };
      
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleSave = () => {
    // Send the updated consumptionConfig to the parent component
    onSave(consumptionConfig);
  };

  // Extract services from the config (excluding metadata)
  const services = Object.entries(consumptionConfig)
    .filter(([key]) => key !== 'metadata')
    .map(([id, service]) => ({ id, ...service }));

  return (
    <div className="container">
      <h2>Consumption Control Settings</h2>
      
      <ConsumptionControlTable 
        services={services}
        metadata={consumptionConfig.metadata}
        onToggleEnabled={handleToggleEnabled}
        onControlToggle={handleControlToggle}
        onOverrideToggle={handleOverrideToggle}
        onHoursChange={handleHoursChange}
        onOverrideTypeChange={handleOverrideTypeChange}
        onPriceBasedHoursChange={handlePriceBasedHoursChange}
        onCurrentAChange={handleCurrentAChange}
      />
      
      <p></p>
      {saveStatus === 'success' && <p><i>Configurations updated successfully!</i></p>}
      {saveStatus === 'error' && <p>Error updating configurations. Please try again.</p>}
      <button onClick={handleSave}>Save Settings</button>
    </div>
  );
};

export default ConsumptionSettings;
